export default class RatingSummary extends HTMLElement
{
    constructor()
    {
        super();
        this.stylesheet = this.getAttribute('stylesheet');
        this.ratingCategory = JSON.parse(this.getAttribute('rating-category'));
    }

    connectedCallback()
    {
        const template = document.querySelector('#rating-summary');
        this._shadowRoot = this.attachShadow({mode: 'open'});
        let instance = template.content.cloneNode(true);
        let ratingElement;
        let ratingTemplate = instance.querySelector('[name="rating-element"]');
        instance.querySelector('[name="stylesheet"]').href = this.stylesheet;

        if (this._checkElementExists(this.ratingCategory) &&
            this._checkElementExists(this.ratingCategory.name) &&
            this._checkElementExists(this.ratingCategory.ratings) &&
            this.ratingCategory.ratings.length > 0
        ) {
            instance.querySelector('[name="rating-category-title"]').innerHTML = this.ratingCategory.name;
            let ratingContainer = instance.querySelector('[name="rating-container"]');
            instance.querySelector('[name="rating-category"]').classList.add('progress-bar-container-' + this.ratingCategory.type);

            this.ratingCategory.ratings.forEach((rateElement, index) =>
            {
                var rateValue = rateElement.rate;
                if(rateValue == 10){
                    rateValue = parseInt(rateValue);
                }

                ratingElement = ratingTemplate.cloneNode(true);
                ratingElement.querySelector('[name="rating-text"]').innerHTML = rateElement.text;
                ratingElement.querySelector('[name="rate"]').innerHTML = rateValue;
                ratingElement.querySelector('[name="progress-bar-value"]').style.width = (rateElement.rate * 100 / this.ratingCategory.maxValue) + "%";
                ratingContainer.appendChild(ratingElement)
            });
        }
        ratingTemplate.remove();

        this._shadowRoot.appendChild(instance);
    }

    _checkElementExists(element)
    {
        if (typeof element !== 'undefined' && element) {
            return true;
        }
        return false;
    }
}